import { Box } from '@mui/material'
import { ProcessingJob } from 'features/jobs/types'
import DownloadsPart from 'features/jobs/ui/JobItem/common/DownloadsPart'
import { FormattedTextBox } from 'features/common/ui/utils/FormattedTextBox'

import settings from 'settings'

interface JobSuccessDownloadProps {
  job: ProcessingJob
  availabilityDate: Date
}

function JobSuccessDownload({ job, availabilityDate }: JobSuccessDownloadProps) {
  const fileCount = parseInt(job?.status?.provider?.statistics?.query?.exportDataStatistics?.fileCount)
  const path = job.response.metadata.uri.replace(settings.exportBucket, settings.exportUrl)
  const basePath = path.split('*')[0]

  const downloadUrls = [...Array(fileCount)].map((_, i) => {
    return `${basePath}${String(i).padStart(12, '0')}.csv`
  })

  return (
    <Box>
      <FormattedTextBox variant="body2" mb={1} id="data-explorer.subscription.exportDialog.download.title" />
      <DownloadsPart downloadUrls={downloadUrls} availableUntil={availabilityDate} />
    </Box>
  )
}

export default JobSuccessDownload
